import { ConfigProvider } from 'antd';
import { useGetDesignConfigQuery } from 'api/DesignApi';
import App from 'App';
import { CompanyConfig, CompanyProvider, defaultCompanyConfig } from 'contexts/CompanyContext';
import { useEffect, useMemo } from 'react';
import { ensureHttp } from 'utils/utils';

const defaultThemeConfig = {
  colorInfo: '#a9a4ed',
  // colorPrimary: '#5449dc',
  // colorPrimaryLighter: '#eeedfb',
  colorTextBase: '#312e4f',
  // colorLink: '#5449dc',
  fontFamily: 'inherit',
  fontFamilyCode: 'inherit'
};

function DesignedApp() {
  const { data: designConfig, isLoading } = useGetDesignConfigQuery({
    origin: window.location.origin
  });

  const companyConfig: CompanyConfig = useMemo(
    () => ({
      isEnterprise: !!designConfig?.companyName,
      companyName: designConfig?.companyName ?? defaultCompanyConfig.companyName,
      contactEmail: designConfig?.email ?? defaultCompanyConfig.contactEmail,
      colorPrimary: designConfig?.colorPrimary ?? defaultCompanyConfig.colorPrimary,
      colorPrimaryLighter: designConfig?.colorPrimaryLighter ?? defaultCompanyConfig.colorPrimaryLighter,
      privacyUrl: ensureHttp(designConfig?.privacyUrl) ?? defaultCompanyConfig.privacyUrl,
      domainUrl: ensureHttp(designConfig?.domainUrl) ?? defaultCompanyConfig.domainUrl,
      termsUrl: ensureHttp(designConfig?.termsUrl) ?? defaultCompanyConfig.termsUrl,
      footerText: designConfig?.footerText ?? defaultCompanyConfig.footerText,
      donationUrl: ensureHttp(designConfig?.donationUrl) ?? defaultCompanyConfig.donationUrl,
      volunteerUrl: ensureHttp(designConfig?.volunteerUrl) ?? defaultCompanyConfig.volunteerUrl,
      logoUrl: designConfig?.logoUrl ?? defaultCompanyConfig.logoUrl
    }),
    [designConfig]
  );

  const theme = {
    token: {
      ...defaultThemeConfig,
      colorPrimary: companyConfig.colorPrimary,
      colorLink: companyConfig.colorPrimary,
      colorInfo: companyConfig.colorPrimaryLighter
    }
  };

  useEffect(() => {
    const root = document.documentElement;

    root.style.setProperty('--color-primary', companyConfig.colorPrimary);
    root.style.setProperty('--color-primary-lighter', companyConfig.colorPrimaryLighter);
  }, [companyConfig]);

  if (isLoading) {
    return null;
  }

  return (
    <CompanyProvider companyConfig={companyConfig}>
      <ConfigProvider theme={theme}>
        <App />
      </ConfigProvider>
    </CompanyProvider>
  );
}

export default DesignedApp;
